export default function addMoneyStatusSelector(
    state: sage.state.IRedux
): sage.status.AddMoneyStatus {
    return state.balance.addMoneyStatus;
}
